// GestorConfiguracionCorreo.js
import React, { useEffect, useState } from "react";
import { 
  getConfiguracionesCorreoCliente, 
  postConfiguracionCorreoCliente, 
  putConfiguracionCorreoCliente,
} from "../../componentes/http/actions/ConfiguracionCorreoClienteAction";
import { getClienteHabilitado } from "../../componentes/http/actions/ClientesAction";
import EditNoteIcon from "@mui/icons-material/EditNote";
import VisibilityIcon from "@mui/icons-material/Visibility"; // Nuevo import
import {
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Grid,
  Typography,
  Box,
  Snackbar,
  Alert,
  TablePagination,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Chip,
  Tooltip,
  IconButton,
} from "@mui/material";
import NuevaConfiguracionCorreoModal from "../../componentes/modal/Correo/NuevoConfiguracionCorreoModal";
import EditarConfiguracionCorreoModal from "../../componentes/modal/Correo/EditarConfiguracionCorreoModal";
import VistaPreviaCorreoModal from "../../componentes/modal/Correo/VistaPreviaCorreoModal"; // Nuevo import

const GestorConfiguracionCorreo = () => {
  const [configuraciones, setConfiguraciones] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [configuracionSeleccionada, setConfiguracionSeleccionada] = useState(null);
  
  // Nuevos estados para vista previa
  const [openVistaPreviaModal, setOpenVistaPreviaModal] = useState(false);
  const [configuracionVistaPrevia, setConfiguracionVistaPrevia] = useState(null);
  
  const [searchTerm, setSearchTerm] = useState("");
  const [filterHabilitado, setFilterHabilitado] = useState("todos");
  const [filterCliente, setFilterCliente] = useState("todos");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    fetchConfiguraciones();
    fetchClientes();
  }, []);

  const fetchConfiguraciones = () => {
    setIsLoading(true);
    getConfiguracionesCorreoCliente(localStorage.getItem("token"))
      .then((response) => {
        setConfiguraciones(response);
      })
      .catch((error) => {
        console.log(error);
        setSnackbar({
          open: true,
          message: "Error al cargar configuraciones",
          severity: "error",
        });
      })
      .finally(() => {
        setIsLoading(false);
        setInitialDataLoaded(true);
      });
  };

  const fetchClientes = () => {
    getClienteHabilitado(localStorage.getItem("token"))
      .then((response) => {
        setClientes(response);
      })
      .catch((error) => {
        console.log("Error al cargar clientes:", error);
      });
  };

  const filterOptions = [
    { value: "todos", label: "Todos" },
    { value: "habilitado", label: "Habilitados" },
    { value: "deshabilitado", label: "Deshabilitados" },
  ];

  const filteredConfiguraciones = configuraciones
    .filter((config) => {
      const matchesSearch = config.nombreCliente
        .toLowerCase()
        .includes(searchTerm.toLowerCase());
      const matchesFilter =
        filterHabilitado === "todos" ||
        (filterHabilitado === "habilitado" && config.habilitado === true) ||
        (filterHabilitado === "deshabilitado" && config.habilitado === false);
      const matchesCliente =
        filterCliente === "todos" || 
        config.idCliente === (filterCliente === "todos" ? config.idCliente : parseInt(filterCliente));
      return matchesSearch && matchesFilter && matchesCliente;
    })
    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  const handleSearchChange = (newSearchTerm) => {
    setSearchTerm(newSearchTerm);
    setPage(0);
  };
  
  const handleFilterChange = (newFilter) => {
    setFilterHabilitado(newFilter);
    setPage(0);
  };

  const handleClienteFilterChange = (event) => {
    setFilterCliente(event.target.value);
    setPage(0);
  };

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  
  const handleOpenEditModal = (configuracion) => {
    setConfiguracionSeleccionada(configuracion);
    setOpenEditModal(true);
  };
  
  const handleCloseEditModal = () => {
    setOpenEditModal(false);
    setConfiguracionSeleccionada(null);
  };

  // Nuevas funciones para vista previa
  const handleOpenVistaPrevia = (configuracion) => {
    setConfiguracionVistaPrevia(configuracion);
    setOpenVistaPreviaModal(true);
  };

  const handleCloseVistaPrevia = () => {
    setOpenVistaPreviaModal(false);
    setConfiguracionVistaPrevia(null);
  };

  const handleNuevaConfiguracion = async (configuracion) => {
    try {
      setIsLoading(true);
      await postConfiguracionCorreoCliente(localStorage.getItem("token"), configuracion);
      await fetchConfiguraciones();
      handleCloseModal();
      setSnackbar({
        open: true,
        message: "Configuración creada con éxito",
        severity: "success",
      });
    } catch (error) {
      console.error("Error al crear configuración:", error);
      setSnackbar({
        open: true,
        message: error.response?.data || "Error al crear configuración",
        severity: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditarConfiguracion = async (editada) => {
    try {
      setIsLoading(true);
      await putConfiguracionCorreoCliente(localStorage.getItem("token"), editada);
      await fetchConfiguraciones();
      handleCloseEditModal();
      setSnackbar({
        open: true,
       message: "Configuración editada con éxito",
       severity: "success",
     });
   } catch (error) {
     console.error("Error al editar configuración:", error);
     setSnackbar({
       open: true,
       message: "Error al editar configuración",
       severity: "error",
     });
   } finally {
     setIsLoading(false);
   }
 };

 const renderNoDataMessage = () => (
   <TableContainer component={Paper}>
     <Box p={3} sx={{ width: "100%" }}>
       <Typography variant="body1" color="text.secondary">
         No se encontraron configuraciones con los criterios de búsqueda actuales.
       </Typography>
     </Box>
   </TableContainer>
 );

 return (
   <Grid container direction="column" spacing={2} sx={{ paddingTop: { xs: "20px", sm: "10px" } }}>
     <Grid item>
       <Grid container justifyContent="space-between" alignItems="center">
         <Typography variant="h4">Configuración de Correos</Typography>
         <Button
           variant="contained"
           color="primary"
           onClick={handleOpenModal}
           disabled={isLoading}
         >
           NUEVA CONFIGURACIÓN
         </Button>
       </Grid>
     </Grid>
     
     {/* Filtros */}
     <Grid item>
       <Grid container spacing={2} alignItems="center">
         <Grid item xs={12} sm={3} md={4}>
           <TextField
             fullWidth
             label="Buscar por cliente"
             variant="outlined"
             value={searchTerm}
             onChange={(e) => handleSearchChange(e.target.value)}
           />
         </Grid>
         <Grid item xs={12} sm={2} md={3}>
           <FormControl variant="outlined" fullWidth>
             <InputLabel>Filtrar por estado</InputLabel>
             <Select
               value={filterHabilitado}
               onChange={(e) => handleFilterChange(e.target.value)}
               label="Filtrar por estado"
             >
               {filterOptions.map((option) => (
                 <MenuItem key={option.value} value={option.value}>
                   {option.label}
                 </MenuItem>
               ))}
             </Select>
           </FormControl>
         </Grid>
           
         <Grid item xs={12} sm={3} md={4}>
           <FormControl variant="outlined" fullWidth>
             <InputLabel>Cliente</InputLabel>
             <Select
               value={filterCliente}
               onChange={handleClienteFilterChange}
               label="Cliente"
             >
               <MenuItem value="todos">Todos</MenuItem>
               {clientes.map((cliente) => (
                 <MenuItem key={cliente.id} value={cliente.id.toString()}>
                   {cliente.nombre}
                 </MenuItem>
               ))}
             </Select>
           </FormControl>
         </Grid>
       </Grid>
     </Grid>
     
     {/* Tabla de datos */}
     <Grid item>
       {isLoading && !initialDataLoaded ? (
         <Box display="flex" justifyContent="center" p={3}>
           <CircularProgress />
         </Box>
       ) : filteredConfiguraciones.length > 0 ? (
         <>
           <TableContainer component={Paper}>
             <Table>
               <TableHead>
                 <TableRow>
                   <TableCell>Id</TableCell>
                   <TableCell>Cliente</TableCell>
                   <TableCell>Colores</TableCell>
                   <TableCell>Configuraciones</TableCell>
                   <TableCell>Habilitado</TableCell>
                   <TableCell align="center">Acciones</TableCell>
                 </TableRow>
               </TableHead>
               <TableBody>
                 {filteredConfiguraciones.map((config, index) => (
                   <TableRow key={index}>
                     <TableCell>{config.id}</TableCell>
                     <TableCell>{config.nombreCliente}</TableCell>
                     <TableCell>
                       <Box display="flex" gap={1} alignItems="center">
                         <Box
                           sx={{
                             width: 20,
                             height: 20,
                             backgroundColor: config.colorPrimario,
                             border: '1px solid #ccc',
                             borderRadius: 1
                           }}
                         />
                       </Box>
                     </TableCell>
                     <TableCell>
                       <Box display="flex" flexWrap="wrap" gap={0.5}>
                         {config.mostrarTipoDocumento && <Chip label="Tipo Doc" size="small" color="primary" />}
                         {config.mostrarDescripcion && <Chip label="Descripción" size="small" color="primary" />}
                         {config.mostrarFechaPublicacion && <Chip label="Fecha Pub" size="small" color="primary" />}
                         {config.mostrarEstado && <Chip label="Estado" size="small" color="primary" />}
                         {config.mostrarUrlExterna && <Chip label="URL" size="small" color="primary" />}
                         {config.mostrarClasificaciones && <Chip label="Clasificaciones" size="small" color="secondary" />}
                         {config.mostrarRubros && <Chip label="Rubros" size="small" color="secondary" />}
                       </Box>
                     </TableCell>
                     <TableCell>
                        <Chip
                          label={config.habilitado ? "Sí" : "No"}
                          color={config.habilitado ? "success" : "error"}
                          size="small"
                        />
                      </TableCell>
                     <TableCell align="center">
                      <Box sx={{ display: "flex", justifyContent: "center", gap: 1}}>
                        <Tooltip title="Vista previa del correo">
                          <IconButton 
                            color="primary"
                            onClick={() => handleOpenVistaPrevia(config)}
                            size="small"
                            disabled={!config.habilitado}
                          >
                            <VisibilityIcon fontSize="small" /> 
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Editar configuración">
                          <IconButton
                            color="primary"
                            onClick={() => handleOpenEditModal(config)}
                            size="small"
                          >
                            <EditNoteIcon fontSize="small" /> 
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </TableCell>
                   </TableRow>
                 ))}
               </TableBody>
             </Table>
           </TableContainer>
           <TablePagination
             rowsPerPageOptions={[10, 25, 50]}
             component="div"
             count={
               configuraciones.filter((config) => {
                 const matchesSearch = config.nombreCliente
                   .toLowerCase()
                   .includes(searchTerm.toLowerCase());
                 const matchesFilter =
                   filterHabilitado === "todos" ||
                   (filterHabilitado === "habilitado" && config.habilitado === true) ||
                   (filterHabilitado === "deshabilitado" && config.habilitado === false);
                 const matchesCliente =
                   filterCliente === "todos" || 
                   config.idCliente === (filterCliente === "todos" ? config.idCliente : parseInt(filterCliente));
                 return matchesSearch && matchesFilter && matchesCliente;
               }).length
             }
             rowsPerPage={rowsPerPage}
             page={page}
             onPageChange={handleChangePage}
             onRowsPerPageChange={handleChangeRowsPerPage}
           />
         </>
       ) : (
         renderNoDataMessage()
       )}
     </Grid>
     
     {/* Modales */}
     <NuevaConfiguracionCorreoModal
       open={openModal}
       onClose={handleCloseModal}
       onSubmit={handleNuevaConfiguracion}
       isLoading={isLoading}
     />
     <EditarConfiguracionCorreoModal
       open={openEditModal}
       onClose={handleCloseEditModal}
       onSubmit={handleEditarConfiguracion}
       configuracion={configuracionSeleccionada}
     />
     
     {/* Nuevo modal de vista previa */}
     <VistaPreviaCorreoModal
       open={openVistaPreviaModal}
       onClose={handleCloseVistaPrevia}
       configuracion={configuracionVistaPrevia}
     />
     
     {/* Notificaciones */}
     <Snackbar
       open={snackbar.open}
       autoHideDuration={6000}
       onClose={() => setSnackbar({ ...snackbar, open: false })}
     >
       <Alert
         onClose={() => setSnackbar({ ...snackbar, open: false })}
         severity={snackbar.severity}
         sx={{ width: "100%" }}
       >
         {snackbar.message}
       </Alert>
     </Snackbar>
   </Grid>
 );
};

export default GestorConfiguracionCorreo;